export interface CircleItem {
  id: number;
  name: string;
  icon: string;
  theme: "primary" | "accent" | "secondary";
  members: string;
  posts: string;
  hot: boolean;
  description: string;
  tags: string[];
}

export const circles: CircleItem[] = [
  {
    id: 1,
    name: "热血追番组",
    icon: "ri-fire-line",
    theme: "primary",
    members: "18.6万",
    posts: "4.2万",
    hot: true,
    description: "燃向、热血、战斗番同好的大本营。每话更新必开新帖，一起喊燃、一起复盘名场面。",
    tags: ["热血", "燃向", "打斗名场面"],
  },
  {
    id: 2,
    name: "悬疑推理圈",
    icon: "ri-search-eye-line",
    theme: "accent",
    members: "12.1万",
    posts: "3.5万",
    hot: true,
    description: "本格推理、都市怪谈、反转剧情党聚集地。每案一推，考据党和脑洞党在这里一决高下。",
    tags: ["本格", "反转", "猜凶手"],
  },
  {
    id: 3,
    name: "恋爱轻语社",
    icon: "ri-heart-3-line",
    theme: "primary",
    members: "15.3万",
    posts: "4.8万",
    hot: true,
    description: "纯爱战士的温柔乡。分享糖分超标的情节，交流磕到cp的心跳瞬间，一起写同人小短篇。",
    tags: ["纯爱", "磕CP", "同人"],
  },
  {
    id: 4,
    name: "科幻星舰港",
    icon: "ri-rocket-2-line",
    theme: "accent",
    members: "9.8万",
    posts: "2.7万",
    hot: false,
    description: "太空歌剧、赛博朋克、硬科幻爱好者的星际码头。聊设定、聊物理、聊宇宙的浪漫。",
    tags: ["太空歌剧", "赛博", "硬科幻"],
  },
  {
    id: 5,
    name: "奇幻世界观",
    icon: "ri-sparkling-2-line",
    theme: "secondary",
    members: "14.7万",
    posts: "4.1万",
    hot: true,
    description: "架空世界、史诗奇幻、魔法的信徒。专门的设定考据楼，从地理、种族到王权制度一网打尽。",
    tags: ["架空", "史诗", "设定考据"],
  },
  {
    id: 6,
    name: "国漫新势力",
    icon: "ri-star-smile-line",
    theme: "primary",
    members: "22.9万",
    posts: "6.6万",
    hot: true,
    description: "支持国产漫画的创作者与读者之家。推荐宝藏国漫、交流行业动态、支持作者创作。",
    tags: ["国漫", "宝藏推荐", "行业"],
  },
  {
    id: 7,
    name: "声优同好圈",
    icon: "ri-vip-crown-2-line",
    theme: "accent",
    members: "7.6万",
    posts: "1.9万",
    hot: false,
    description: "声控党的天堂。分享配音现场、安利心头好声优，一起扒幕后配音花絮和广播剧。",
    tags: ["声控", "广播剧", "幕后"],
  },
  {
    id: 8,
    name: "漫画绘技营",
    icon: "ri-pencil-ruler-2-line",
    theme: "secondary",
    members: "5.2万",
    posts: "1.5万",
    hot: false,
    description: "想画漫画的同好互助营。分享线稿、上色和分镜教程，晒稿求点评，一起从菜鸟变大大。",
    tags: ["绘画", "分镜", "教程"],
  },
];